import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';
import {
    SubmitPurchaseOrderInput,
    SubmitPurchaseOrderResponse,
} from '../../types/inventory/purchaseOrders';

const submitPurchaseOrder = async (
    sessionId: string,
    input: SubmitPurchaseOrderInput,
): Promise<SubmitPurchaseOrderResponse> => {
    const { data } = await axios.post(`${API_URL}/inventory/purchase-orders/submit`, input, {
        headers: { Authorization: sessionId },
    });
    return data;
};

export const useSubmitPurchaseOrder = (
    options?: UseMutationOptions<SubmitPurchaseOrderResponse, unknown, SubmitPurchaseOrderInput>,
) => {
    const sessionContext = useContext(SessionContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (input: SubmitPurchaseOrderInput) =>
            submitPurchaseOrder(sessionContext?.sessionId ?? '', input),
        ...options,
        onSuccess: (...args) => {
            queryClient.invalidateQueries({ queryKey: ['/inventory/purchase-orders/feed'] });
            queryClient.invalidateQueries({ queryKey: ['/order/detail'] });
            queryClient.invalidateQueries({ queryKey: ['/inventory/feed'] });
            options?.onSuccess?.(...args);
        },
    });
};
